// extracted by mini-css-extract-plugin
export default {"root":"FloatingToggleButton_root__V3KbR","enabled":"FloatingToggleButton_enabled__1cQIE","disabled":"FloatingToggleButton_disabled__DJkSR"};